(function () {
  document.addEventListener('DOMContentLoaded', function () {
    // Only headings that should toggle
    var headings = document.querySelectorAll('.footer-block__heading.accordion-title');
    if (!headings.length) return;

    headings.forEach(function (h) {
      var block = h.closest('.footer-block');

      // Mark the block as an accordion (so CSS applies)
      if (block) block.classList.add('is-accordion');

      // Accessibility
      h.setAttribute('tabindex', '0');
      h.setAttribute('role', 'button');
      h.setAttribute('aria-expanded', 'false');

      var toggle = function () {
        var nowOpen = !block.classList.contains('is-open');

        // Close others
        document.querySelectorAll('.footer-block.is-open').forEach(function (b) {
          if (b !== block) {
            b.classList.remove('is-open');
            var head = b.querySelector('.footer-block__heading.accordion-title');
            if (head) head.setAttribute('aria-expanded', 'false');
          }
        });

        // Toggle current
        block.classList.toggle('is-open', nowOpen);
        h.setAttribute('aria-expanded', nowOpen ? 'true' : 'false');
      };

      h.addEventListener('click', toggle);
      h.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          toggle();
        }
      });
    });
  });
})();
